module.exports = __webpack_public_path__ + "files/3806d3a6502fde9c74f96e35efa09597.png";